import SettingsLayout from 'modules/profile/components/settings-layout'
import { settingsMenuLocoKeys } from 'modules/profile/constants/settings-menu-loco-keys'
import {
  ActiveCampaignIntegration,
  ActiveCampaignIntegrationComingSoon,
} from 'modules/profile/integrations/active-campaign-integration'
import { integrationsLoco } from 'modules/profile/integrations/constants/loco'
import {
  GoogleCalendarIntegration,
  GoogleCalendarIntegrationComingSoon,
} from 'modules/profile/integrations/google/calendar'
import {
  GoogleMeetIntegration,
  GoogleMeetIntegrationComingSoon,
} from 'modules/profile/integrations/google/meet'
import {
  GoogleSheetsIntegration,
  GoogleSheetsIntegrationComingSoon,
} from 'modules/profile/integrations/google/sheets'
import { TwilioIntegration } from 'modules/profile/integrations/twilio'
import { ZoomIntegration, ZoomIntegrationComingSoon } from 'modules/profile/integrations/zoom'
import {
  getHostOnServerServerSideProps,
  HostOnServerInterface,
} from 'modules/white-label/util/get-host-on-server'
import { getWhiteLabelChecks } from 'modules/white-label/util/get-white-label-checks'
import { NextPage } from 'next'
import { useState } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import useUser from 'shared/hooks/use-user'
import {
  getBaseServerSideProps,
  getCombinedServerSideProps,
} from 'shared/utils/get-base-server-side-props'

const Integrations: NextPage<HostOnServerInterface> = ({ hostOnServer }) => {
  const { isWorkspaceOwner } = useUser()
  const { t } = useLocoTranslation()
  const [openedGoogleCalendarIntegration, setOpenedGoogleCalendarIntegration] = useState(false)

  const { isSio } = getWhiteLabelChecks({ hostOnServer })

  return (
    <SettingsLayout
      needSave={false}
      titles={[{ caption: t(settingsMenuLocoKeys.integrations), isStatic: true }]}
    >
      <div>
        <div className={'flex flex-col flex-wrap gap-3 md:flex-row'}>
          {isSio ? <ZoomIntegration /> : <ZoomIntegrationComingSoon />}
          {isSio ? (
            <GoogleMeetIntegration
              onManageCalendar={() => {
                setOpenedGoogleCalendarIntegration(true)
              }}
            />
          ) : (
            <GoogleMeetIntegrationComingSoon />
          )}
          {isSio ? <GoogleSheetsIntegration /> : <GoogleSheetsIntegrationComingSoon />}
          {isWorkspaceOwner &&
            (isSio ? <ActiveCampaignIntegration /> : <ActiveCampaignIntegrationComingSoon />)}
          {isSio ? (
            <GoogleCalendarIntegration
              opened={openedGoogleCalendarIntegration}
              setOpened={setOpenedGoogleCalendarIntegration}
            />
          ) : (
            <GoogleCalendarIntegrationComingSoon />
          )}
          <TwilioIntegration />
        </div>
      </div>
    </SettingsLayout>
  )
}

export const getServerSideProps = getCombinedServerSideProps(
  getBaseServerSideProps(integrationsLoco, 'global.settings'),
  getHostOnServerServerSideProps,
)

export default Integrations
